<template>
  <v-card
    class="video-card elevation-0 pr-0 pr-md-6"
    :width="$vuetify.breakpoint.xs ? '100%' : $vuetify.breakpoint.md ? '100%' : $vuetify.breakpoint.lg ? '100%' :  '100%'"
    :min-width="$vuetify.breakpoint.xs ? 0 : $vuetify.breakpoint.md ? 0 : $vuetify.breakpoint.lg ? 0 : 0"
    :style="{borderRadius: '0', backgroundColor: 'transparent'}"
    :to="linkTo"
    :href="hrefTo"
    :class="{'live-event-card': data && data.__typename === 'LiveEvent'}"
    >
    <v-img
      :src="optimizedImageURL(data.thumbnail, {maxWidth: 400, maxHeight: 400})"
      :lazy-src="getLazySrc(data.thumbnail)"
      :aspect-ratio="getAspectRatio(data.thumbnail)"
      contain
      width="100%"
      height="100%"
    />
    <v-card-title>
      <h2 class="d-block text-sans" :class="{ 'text-truncate' : $vuetify.breakpoint.mdAndUp && data.__typename !== 'LiveEvent'}">{{data.title}}</h2>
    </v-card-title>
    <v-card-text>
      <template v-if="data.description">
        <MarkdownBlock class="body-2 description" :text="data.description" v-if="$vuetify.breakpoint.mdAndUp || read"/>
        <v-btn v-if="$vuetify.breakpoint.smAndDown" text class="body-2 read-more px-0" @click.prevent="read = !read">{{ !read ? 'Read more' : 'Read less' }}</v-btn>
      </template>
      <p class="body-1" v-if="data.duration">{{data.duration}}</p>
      <a v-if="data.artistLink" :href="data.artistLink" @click.capture.stop target="_blank" class="d-block text-decoration-underline">Artist Link</a>
      <a v-if="data.moreInfoLink" :href="data.moreInfoLink.url" @click.capture.stop target="_blank" class="d-block text-decoration-underline">{{data.moreInfoLink.label}}</a>
    </v-card-text>
  </v-card>
</template>
<script>
import { MarkdownBlock } from '@monogrid/vue-lib'
import { optimizedImageURL, getLazySrc, getAspectRatio } from '@/services/OptimizedImage'

export default {
  name: 'VideoCard',
  data () {
    return {
      read: false
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    MarkdownBlock
  },
  methods: {
    optimizedImageURL,
    getLazySrc,
    getAspectRatio
  },
  computed: {
    linkTo () {
      if (this.data.__typename === 'LiveEvent') {
        if (this.data.recordingURL && (this.data.recordingURL.toLowerCase().indexOf('youtu') !== -1 || this.data.recordingURL.toLowerCase().indexOf('vimeo') !== -1 || this.data.recordingURL.toLowerCase().indexOf('cove.') !== -1)) {
          return { name: 'LiveEventPlayer', params: { slug: this.data._slug } }
        }
      } else if (this.data.__typename === 'Video') {
        return { name: 'VideoExhibition', params: { videoSlug: this.data._slug } }
      }
      return null
    },
    hrefTo () {
      if (this.data.__typename === 'LiveEvent') {
        if (this.data.recordingURL && (this.data.recordingURL.toLowerCase().indexOf('youtu') === -1 && this.data.recordingURL.toLowerCase().indexOf('vimeo') === -1 && this.data.recordingURL.toLowerCase().indexOf('cove.') === -1)) {
          return this.data.recordingURL
        }
      }
      return null
    }
  }
}
</script>

<style lang="scss">

::v-deep .read-more {
  span {
    justify-content: flex-start;
  }
}

.video-card {
  margin: 0 !important;

  &::before {
    display: none;
  }

  h2 {
    word-break: normal;

    @include breakpoint('sm-and-down') {
      font-size: 1.25rem;
      // word-break: break-word;
    }
  }

  p {
    @include breakpoint('sm-and-down') {
      font-size: 0.825rem;
    }
  }

  .description {
    a {
      text-decoration: underline;
    }
  }
}

.live-event-card {
  h2 {
    font-size: 1.25rem !important;
  }
}

</style>
